<script lang="ts">
    //Props
    export let href: string;

    //Optional props
    export let ariaLabel: string | null = null;
    export let download: string | null = null;
</script>

<a {href} {download} class="gw-rd-link" aria-label={ariaLabel} on:click>
    <slot />
</a>

<style lang="postcss">
    .gw-rd-link {
        color: var(--gw-rd-content__links-theme-color);
    }
</style>
